import {
  START_LESSON,
  START_LESSON_SUCCESS,
  START_LESSON_CLEAN,
  START_LESSON_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  lesson: {},
}

const LessonStart = (state = initialState, action) => {
  switch (action.type) {
    case START_LESSON:
      state = {
        ...state,
        loading: true,
      }
      break
    case START_LESSON_SUCCESS:
      state = {
        ...state,
        lesson: action.payload.lesson,
        loading: false,
        done: true,
      }
      break
    case START_LESSON_CLEAN:
      state = initialState
      break
    case START_LESSON_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default LessonStart
